/**
 * Updates input fields within elements having the class .js-form-page-title.
 *
 * For each .js-form-page-title element, it retrieves the value of the data-page attribute
 * and sets it as the value of an input element with the class .js-form-page located within
 * the same parent element.
 */

function updateFormInputs() {
    // Select all elements with the class .js-form-page-title
    const pageTitles = document.querySelectorAll('.js-form-page-title');

    pageTitles.forEach(pageTitle => {
        // Get the value from the data-page attribute
        const pageData = pageTitle.getAttribute('data-page');

        if (pageData) {
            // Find the input with the class .js-form-page within the same .js-form-page-title element
            const input = pageTitle.querySelector('.js-form-page');

            if (input) {
                // Set the value of the input to the data-page attribute value
                
                input.setAttribute('value', pageData);
            }
        }
    });
}

const initContactFormBlock = () => {
    updateFormInputs();

    // Find all instances of the file upload components
    const fileWrappers = document.querySelectorAll('.js-form-file-wrapper');

    fileWrappers.forEach(wrapper => {
        const filePlug = wrapper.querySelector('.js-form-file-plug');
        const fileInput = wrapper.querySelector('.js-form-file');

        // Handle click event on the file plug
        filePlug.addEventListener('click', () => {
            fileInput.click();
        });

        // Handle change event on the file input
        fileInput.addEventListener('change', () => {
            if (fileInput.files.length > 0) {
                filePlug.textContent = fileInput.files[0].name;
            } else {
                filePlug.textContent = 'File Upload';
            }
        });
    });
};

document.addEventListener('DOMContentLoaded', initContactFormBlock, false)